module.exports = __webpack_public_path__ + "img/siem.3c4f012.svg";